import React, { useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { useTranslation } from "react-i18next";

import { SolidButton } from "../buttons/SolidButton";
import googleSvg from "../../assets/svg/google.svg";
import loadingSpinner from "../../assets/svg/spinner.svg";
import { useAppDispatch } from "../../store/hooks";
import { LoginWithGoogle } from "../../store/actions/authActions/LoginWithGoogle";
import { GlobalError } from "../errors/GlobalError";
import { useNavigate } from "react-router-dom";

interface Props {
  small?: boolean;
  persistentLogin: boolean;
  signup: boolean;
  setRedirect: React.Dispatch<React.SetStateAction<boolean>>;
  qrTokenToValidate?: string;
  setGoogleToken?: React.Dispatch<React.SetStateAction<string | null>>;
}

export const GoogleAuthButton: React.FC<Props> = ({
  small,
  persistentLogin,
  signup,
  setRedirect,
  qrTokenToValidate,
  setGoogleToken,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const language = t("localization_testing");
  const dispatch = useAppDispatch();

  const onLoginSuccess = (res: any) => {
    console.log("here is the loginSuccess res.crediential", res.credential);
    if (!!setGoogleToken) {
      return setGoogleToken(res.credential);
    } else
      return dispatch(
        LoginWithGoogle(
          language,
          res.credential,
          persistentLogin,
          signup,
          navigate,
          setRedirect,
          setLoading,
          qrTokenToValidate
        )
      );
  };

  const onLoginFailure = (res: any) => {
    console.log("this is the onLoginFailure response", res);
    GlobalError(res);
  };

  return (
    <>
      <div className="w-full cursor-pointer">
        <div
          className={`${
            small ? "" : "ml-8 md:-ml-2 xl:ml-2"
          } absolute mt-0.5 opacity-0`}
        >
          <GoogleLogin
            onSuccess={(credentialResponse) => {
              console.log(
                "this is onSuccess crediential response",
                credentialResponse
              );
              onLoginSuccess(credentialResponse);
            }}
            onError={() => {
              console.log("this is on error");
              onLoginFailure(null);
            }}
            theme="filled_blue"
            size="large"
            text="continue_with"
            shape="circle"
            logo_alignment="center"
            locale={t("localization_testing")}
          />
        </div>
        <div>
          <SolidButton
            blackText
            backgroundColor="bg-blue-200"
            hoverColor="hover:bg-blue-300"
            width="w-full"
            disabled={true}
          >
            <div className="flex items-center cursor-pointer">
              {loading ? (
                <div>
                  <img
                    className="h-5 animate-spin"
                    src={loadingSpinner}
                    alt="loading"
                  />
                </div>
              ) : (
                <div className="flex space-x-2">
                  <span>{t("form.continueWith")}</span>
                  <img className="h-5" src={googleSvg} alt="google" />
                </div>
              )}
            </div>
          </SolidButton>
        </div>
      </div>
    </>
  );
};
